import React from 'react'
import MaterialSymbol from '../material-symbol'

const CollectionsBookmark = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="collections_bookmark" {...props} />
))

CollectionsBookmark.displayName = 'CollectionsBookmark'

export default CollectionsBookmark
